/**
 * Language code to display name mapping for content search filters
 */
const LANGUAGE_MAP: Record<string, string> = {
  ar: 'Arabic',
  de: 'German',
  en: 'English',
  es: 'Spanish',
  fr: 'French',
  hi: 'Hindi',
  it: 'Italian',
  pt: 'Portuguese',
  ru: 'Russian',
};

/**
 * Get the display name for a language code
 * @param code - The language code (e.g., 'en', 'es', 'fr')
 * @returns The display name for the language (e.g., 'English', 'Spanish', 'French')
 */
export function getLanguageDisplayName(code: string): string {
  return LANGUAGE_MAP[code] || code;
}

/**
 * Get all available language options for dropdowns
 * @returns Array of language options with value and label
 */
export function getLanguageOptions() {
  return [{ value: 'all', label: 'All' }, ...Object.entries(LANGUAGE_MAP).map(([value, label]) => ({ value, label }))];
}

/**
 * Get all supported language codes
 * @returns Array of language codes
 */
export function getSupportedLanguageCodes(): string[] {
  return Object.keys(LANGUAGE_MAP);
}
